/**
 * Browse Challenge Card — wrapper around ChallengeCard for catalog/browse views.
 * Converts BrowseChallengeItem to ChallengeCard props.
 */

import { memo } from 'react'
import { ChallengeCard } from './challenge-card'
import type { BrowseChallengeItem } from '@turnifly/shared/api'

interface BrowseChallengeCardProps {
  challenge: BrowseChallengeItem
}

export const BrowseChallengeCard = memo(function BrowseChallengeCard({
  challenge: c,
}: BrowseChallengeCardProps): React.ReactElement {
  return (
    <ChallengeCard
      challengeId={c.id}
      name={c.name}
      coverEmoji={c.cover_emoji}
      coverGradient={c.cover_gradient}
      coverImageUrl={c.cover_image_url}
      type={c.type}
      status={c.status}
      startDate={c.start_date}
      endDate={c.end_date}
      durationDays={c.duration_days}
      membersCount={c.members_count}
      timeModel={c.time_model}
      showJoinBtn
    />
  )
})
